import type { SVGProps } from 'react';

export const DoubleArrowRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M5.29293 6.29285C5.68353 5.90254 6.31578 5.90237 6.70628 6.29285L11.7058 11.2934C12.0964 11.6839 12.0964 12.3161 11.7058 12.7067L6.70628 17.7072C6.31581 18.0976 5.68354 18.0974 5.29293 17.7072C4.90236 17.3166 4.90236 16.6845 5.29293 16.2939L9.58697 12L5.29293 7.70614C4.90236 7.31558 4.90236 6.68342 5.29293 6.29285Z" />
    <path d="M12.293 6.29285C12.6835 5.90234 13.3158 5.90243 13.7064 6.29285L18.7071 11.2934C19.0976 11.6839 19.0976 12.3161 18.7071 12.7067L13.7064 17.7072C13.3158 18.0975 12.6835 18.0977 12.293 17.7072C11.9026 17.3167 11.9027 16.6844 12.293 16.2939L16.587 12L12.293 7.70614C11.9026 7.31564 11.9027 6.68339 12.293 6.29285Z" />
  </svg>
);
